import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import CommonControlWrapper from "nexia_mobile/components/Controls/wrappers/CommonControlWrapper";
import DeviceControlButton from "nexia_mobile/components/Controls/DeviceControlButton";

const ActivateAutomation = ({
  model,
  isDetailed,
  showSpinner,
  hideSpinner,
}) => (
  <CommonControlWrapper isDetailed={isDetailed}>
    <DeviceControlButton
      buttonLabel="Run Now"
      onTap={() => {
        showSpinner(`Running '${model.get("name")}'`);
        model.activate().then(hideSpinner, hideSpinner);
      }}
    />
  </CommonControlWrapper>
);
ActivateAutomation.propTypes = {
  model: PropTypes.instanceOf(Backbone.Model).isRequired,
  isDetailed: PropTypes.bool.isRequired,
  showSpinner: PropTypes.func.isRequired, // (?string) => void
  hideSpinner: PropTypes.func.isRequired, // () => void
};

export default ActivateAutomation;



// WEBPACK FOOTER //
// ./src/components/Controls/ActivateAutomation.jsx